/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum FileType {
    CSV = 'Csv',
    EXCEL = 'Excel',
    PDF = 'Pdf',
    DOC = 'Doc',
    PNG = 'Png',
    JPG = 'Jpg',
    TXT = 'Txt',
    URL = 'URL',
    BASE64 = 'Base64',
    NONE = 'None',
}
